import { useState } from 'react';
import type { LinkValue } from '../../lib/fieldValue';
import type { Field } from '../../lib/templates';

interface LinkFieldProps {
  field: Pick<Field, 'label'>;
  value: LinkValue | null;
  onCommit: (value: LinkValue | null) => void;
  disabled?: boolean;
}

/** `LinkValue` has no footnote/note — a link is either set or it isn't. */
export function LinkField({ field, value, onCommit, disabled = false }: LinkFieldProps) {
  const [url, setUrl] = useState(value?.url ?? '');
  const [label, setLabel] = useState(value?.label ?? '');

  function commit() {
    if (disabled) {
      return;
    }
    if (url.trim() === '') {
      onCommit(null);
      return;
    }
    onCommit({ type: 'LINK', url: url.trim(), label: label.trim() === '' ? null : label.trim() });
  }

  return (
    <div className="flex flex-col gap-3">
      <label className="flex flex-col gap-1 text-sm text-text-muted">
        <span className="eyebrow">{field.label} URL</span>
        <input
          type="url"
          value={url}
          disabled={disabled}
          onChange={(event) => setUrl(event.target.value)}
          onBlur={commit}
          placeholder="https://…"
          className="rounded-md border border-border-strong bg-bg px-3 py-2 text-text focus:border-accent"
        />
      </label>
      <label className="flex flex-col gap-1 text-sm text-text-muted">
        <span className="eyebrow">Label (optional)</span>
        <input
          type="text"
          value={label}
          disabled={disabled}
          onChange={(event) => setLabel(event.target.value)}
          onBlur={commit}
          className="rounded-md border border-border-strong bg-bg px-3 py-2 text-text focus:border-accent"
        />
      </label>
    </div>
  );
}
